export default "__VITE_ASSET__DFHOE9G4__"